import React from 'react';
import PropTypes from 'prop-types';
import useSWR from 'swr';
import {withSize} from 'react-sizeme';
import {formatter} from '../../../shared/utils/utils';
import AccountsTable from '../../shared/widgets/containers/AccountsTable';
import {Column, DescriptiveText, LoadingSpinner, Row, TitleLabel} from '../../../shared';

/**
 * GroupInfo component
 * @name GroupInfo
 */
const GroupInfo = ({
  containerID,
  size,
}) => {
  const {data: group, error: groupError} = useSWR(`/containers/${containerID}`);

  if (groupError) {
    return <DescriptiveText>
      {groupError?.response?.data.error?.msg || 'Failed to load data from API.'}
    </DescriptiveText>;
  }

  if (!group) {
    return <LoadingSpinner/>;
  }

  return <Column>
    <Row alignItems={'top'} justifySubRow={'space between'} width={'100%'}>
      <Column alignItems={size.width <= 300 ? 'center' : 'left'} justifySubColumn={'top'} width={size.width <= 300 ? '100%' : '50%'}>
        <TitleLabel title={'Group Name'} margin={'5px'}/>
        <DescriptiveText alignment={'left'} fontSize={'12px'} font={'ProximaRegular'} width={'fit-content'} margin={'5px 5px 10px 5px'}>
          {group.name}
        </DescriptiveText>
      </Column>
      <Column alignItems={size.width <= 300 ? 'center' : 'right'} justifySubColumn={'top'} width={size.width <= 300 ? '100%' : '50%'}>
        <DescriptiveText alignment={'left'} fontSize={'20px'} font={'ProximaSemibold'} width={'fit-content'}>
          {formatter('currency')(group.balance.amount)}
        </DescriptiveText>
        <DescriptiveText alignment={'left'} fontSize={'10px'} font={'ProximaLight'} width={'fit-content'}>
          Last Updated: {formatter('date')(group.updatedAt)}
        </DescriptiveText>
      </Column>
    </Row>
    {size.width > 300 && <AccountsTable containerID={group.id} rowsPerPage={10}/>}
  </Column>;
};

export default withSize()(GroupInfo);

GroupInfo.propTypes = {
  /**
   * The group ID
   */
  containerID: PropTypes.number.isRequired,
  size: PropTypes.object,
};
